<template>
  <div class="pictures-content">
    <div class="container">
      <!-- 卡片列表 -->
      <v-panel-content :data-salce="triggerSideNavShow" />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getSchema } from "@/api/configs.js";
export default {
  name: "page",

  data() {
    return {};
  },
  components: {},
  computed: {
    ...mapState("mixins", ["triggerSideNavShow"]),
  },
  created() {
    this.get_picture_list();
  },
  mounted() {},
  beforeDestroy() {},
  methods: {
    ...mapMutations("favorites", ["updateFavoritesId"]),
    ...mapMutations("triggerEvtents", ["updateInitSearchCondition"]),
    async get_picture_list() {
      this.updateInitSearchCondition();
      this.$P.schemaType = "favoritePictures";
      this.updateFavoritesId(null);
    },
  },
};
</script>

<style  lang="scss">
.pictures-content {
}
</style>
